import { useMemo } from 'react';
import { useAccount, useChainId, useConfig } from 'wagmi';

import { useNetwork } from 'src/provider/NetworkProvider';
import { getChainConfig, getChainId } from 'src/utils/chainUtils';

export const useWeb3 = () => {
  const { chain } = useAccount();
  const config = useConfig();
  const chainId = useChainId();
  const { selectedNetwork, isNetworkInitialized } = useNetwork();

  const targetChainId = useMemo(() => {
    if (!selectedNetwork || !isNetworkInitialized) return null;
    const chainId = getChainId(selectedNetwork);
    return chainId;
  }, [selectedNetwork, isNetworkInitialized]);

  const isWrongNetwork = useMemo(() => {
    if (!selectedNetwork || !isNetworkInitialized) return false;
    const targetChainId = getChainId(selectedNetwork);
    return chainId !== targetChainId;
  }, [selectedNetwork, isNetworkInitialized, chainId]);

  const chainConfig = useMemo(() => {
    if (!selectedNetwork || !isNetworkInitialized) return null;
    const chainConfig = getChainConfig(selectedNetwork);
    return chainConfig;
  }, [selectedNetwork, isNetworkInitialized]);

  return {
    chain,
    chainId,
    chainConfig,
    config,
    isWrongNetwork,
    targetChainId,
  };
};
